import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { TextField, Checkbox, FormControlLabel, Grid, Button } from '@material-ui/core';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import * as Actions from './store/actions';
import * as validatorActions from '../../components/validator/store/actions'
import ComponentTrackingInfo from '../../components/ComponentTrackingInfo';
import { getSharedTextFieldProps } from '../../components/helpers';

const styles = theme => ({
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        width: '80%',
    },
    textFieldSearch: {
        marginLeft: theme.spacing.unit,
        width: '95%',
    },
    button: {
        margin: theme.spacing.unit,
    },
    editor: {
        "min-height": "150px"
    },
    root: {
        backgroundColor: theme.palette.background.paper,
        width: 500,
    },
    readOnlyMargin: {
        marginLeft: '16px'
    },
    hiddenWhenEmptyValue: {
        display: 'none'
    }
});

class MajorForm extends Component {

    handleTabChange = (event, value) => {
        this.setState({ majorTabValue: value });
    };

    handleChange = field_name => event => {

        let value = event.target.value;
        if (event.target.type === 'checkbox') {
            value = event.target.checked ? 1 : 0;
        }

        const update_data = {
            [field_name]: value
        }
        const validator = {
            field_name, value
        }

        this.props.runValidator(validator)

        this.props.updateMajorForm(update_data);
    }

    render() {
        const { classes, view_type, theme, major, validator } = this.props;

        return (
            <div className="p-24">
                <Grid container spacing={24}>
                    <Grid item xs={6}>
                        <form className={classes.container} noValidate autoComplete="off">
                            <Grid item xs={12}>
                                <TextField
                                    required
                                    id="MajorName"
                                    label="Major Name"
                                    value={major.MajorName}
                                    onChange={this.handleChange('MajorName')}
                                    error={validator.filter(v => v.field_name === 'MajorName')[0].error}
                                    helperText={validator.filter(v => v.field_name === 'MajorName')[0].error_msg}
                                    {...getSharedTextFieldProps(view_type, classes)}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    id="MajorDescription"
                                    label="Major Description"
                                    value={major.MajorDescription}
                                    onChange={this.handleChange('MajorDescription')}
                                    {...getSharedTextFieldProps(view_type, classes)}
                                    className={(major.MajorDescription === (undefined || '') && view_type === 'detail') ? [classes.hiddenWhenEmptyValue, classes.textField] : classes.textField}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={(major.Active === 1 || major.Active === true)}
                                            onChange={(view_type === 'detail') ? undefined : this.handleChange('Active')}
                                            disableRipple={view_type === 'detail'}
                                            value="Active"
                                            color="primary"
                                        />
                                    }
                                    label="Active"
                                />
                            </Grid>
                        </form>

                    </Grid>
                    <Grid item xs={6}>
                        <ComponentTrackingInfo
                            editInfo={this.props.editInfo}
                            view_type={this.props.view_type}
                            classes={classes}
                        />
                    </Grid>
                </Grid>
            </div>
        )
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getMajor: Actions.getMajor,
        deleteMajor: Actions.deleteMajor,
        saveMajor: Actions.saveMajor,
        updateMajorForm: Actions.updateMajorForm,
        toggleCourse: Actions.toggleCourse,
        toggleCompany: Actions.toggleCompany,
        runValidator: validatorActions.runValidator
    }, dispatch);
}

function mapStateToProps({ majorApp, auth, validator }) {
    return {
        major: majorApp.majors.currentMajor,
        auth,
        validator: validator.list,
        editInfo: majorApp.majors.editInfo
    }
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(MajorForm)));



// WEBPACK FOOTER //
// src/main/content/major/MajorForm.js